"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStripeIdentityRequest = exports.axiosClient = void 0;
var axios_1 = __importDefault(require("axios"));
// Setup local instance of axios with default url and headers
var axios = axios_1.default.create({
    baseURL: "".concat(((_a = window.TeamSnap) === null || _a === void 0 ? void 0 : _a.apiv3Url) || 'http://localhost:3000'),
    headers: {
        Accept: 'application/vnd.api.v1.0.0+json',
        authorization: "Bearer ".concat((_b = window.TeamSnap) === null || _b === void 0 ? void 0 : _b.authenticationToken),
    },
});
// Add start and end times to axios request and response objects
axios.interceptors.request.use(function (config) { return (__assign(__assign({}, config), { startTime: new Date().getTime() })); });
var onGetSuccess = function (result) {
    var _a = result.config, url = _a.url, params = _a.params, method = _a.method, headers = _a.headers, startTime = _a.startTime, data = result.data, status = result.status, statusText = result.statusText;
    console.log('Success - StripeIdentities API GET', {
        request: { time: "".concat(new Date().getTime() - startTime, " ms"), url: url, params: params, method: method, headers: headers, status: status, statusText: statusText },
        response: data,
        data: data.collection.items[0].data,
    });
    return data.collection.items[0].data;
};
var onPostSuccess = function (result) {
    var _a = result.config, url = _a.url, params = _a.params, method = _a.method, headers = _a.headers, startTime = _a.startTime, endTime = _a.endTime, data = result.data, status = result.status, statusText = result.statusText;
    console.log('Success - StripeIdentities API POST', {
        request: { time: "".concat(endTime - startTime, " ms"), url: url, params: params, method: method, headers: headers, status: status, statusText: statusText },
        response: data,
        data: data.collection.items[0].data,
    });
    return data.collection.items[0].data;
};
var onError = function (error) {
    console.log('Stripe API Request Failed: ', error);
    return Promise.reject(error);
};
exports.axiosClient = axios;
var getStripeIdentityRequest = function () {
    return axios({
        method: 'GET',
        url: '/stripe_identities/search',
        params: {
            user_id: window.TeamSnap.userId,
            team_id: window.TeamSnap.teamId,
        },
    })
        .then(function (data) { return onGetSuccess(data); })
        .catch(onError);
};
exports.getStripeIdentityRequest = getStripeIdentityRequest;
